import {Injectable} from "@angular/core";

@Injectable()
export class Utils {
    sortList(list: any[], field: string) {
        list.sort((a: any, b:any) => {
            if (a[field] > b[field]) {
                return 1;
            } else if (a[field] < b[field]) {
                return -1;
            }

            return 0;
        });
    }

    hash(hash: any, list: any[], field: string = 'id') {
        list.forEach((value: any) => {
            hash[value[field]] = value;
        });
    }

    orderByList(list: any[], field: string) {
        return list.sort( (a: any, b:any) => {
            return a[field] - b[field];
        })
    }

    cloneList(list: any) {
        let target = [];
        for (let prop in list) {
            if (list.hasOwnProperty(prop)) {
                target[prop] = list[prop];
            }
        }
        return target;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/utils.service.ts